import { defineStore } from 'pinia'
import { ref } from 'vue'
import { api } from '@/boot/axios'
import { fixImageOrientation } from '@/utils/imageOrientation'

export const useUserStore = defineStore('user', () => {
  const profile = ref({
    name: '',
    email: '',
    phone: '',
    avatar_url: null,
    notify_client_activity: false,
    cc_receipts_default: false,
    notify_event_registrations: false,
    notify_morning_digest_email: false,
    notify_eod_digest_email: false,
    notify_morning_digest_push: false,
    notify_eod_digest_push: false
  })

  async function fetchProfile() {
    const response = await api.get('/profile')
    profile.value = response.data
    return response.data
  }

  async function updateProfile(data) {
    const response = await api.put('/profile', data)
    profile.value = response.data
    return response.data
  }

  async function updateProfilePicture(profilePictureFile) {
    if (!(profilePictureFile instanceof File)) {
      throw new Error('Profile picture must be a File object')
    }

    const fixedFile = await fixImageOrientation(profilePictureFile)
    const formData = new FormData()
    formData.append('profile_picture', fixedFile)

    const response = await api.post('/profile/picture', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    profile.value = response.data
    return response.data
  }

  return {
    profile,
    fetchProfile,
    updateProfile,
    updateProfilePicture
  }
})
